import { useState } from 'react'
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useI18n } from '../i18n/useI18n'
import { Icon } from './Icon'
import { LanguageToggle } from './LanguageToggle'

export function TopNav() {
  const { t } = useI18n()
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const linkBase =
    'font-body-md text-body-md relative rounded px-3 py-2 transition-colors duration-200'
  const linkClass = ({ isActive }: { isActive: boolean }) =>
    isActive
      ? `${linkBase} text-primary font-bold after:absolute after:bottom-0 after:left-1/2 after:h-0.5 after:w-5 after:-translate-x-1/2 after:rounded-full after:bg-primary`
      : `${linkBase} text-on-surface-variant hover:text-primary`

  const items = [
    { to: '/', label: t.nav.home, end: true },
    { to: '/catalog', label: t.nav.skills, end: false },
    { to: '/workflows', label: t.nav.workflows, end: false },
    { to: '/gallery', label: t.nav.gallery, end: false },
  ]

  return (
    <header className="sticky top-0 z-50 w-full border-b border-outline-variant bg-surface/90 backdrop-blur-xl shadow-sm">
      <div className="mx-auto flex h-16 max-w-container-max items-center justify-between px-4 md:px-margin-desktop">
        <Link
          to="/"
          className="flex items-center gap-2 font-headline-md text-headline-md font-bold text-primary"
        >
          <Icon name="architecture" size={22} />
          {t.brand}
        </Link>

        <nav className="hidden items-center gap-1 md:flex">
          {items.map((it) => (
            <NavLink key={it.to} to={it.to} end={it.end} className={linkClass}>
              {it.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden items-center gap-4 md:flex">
          <LanguageToggle />
          <button
            type="button"
            onClick={() => navigate('/workflows/ai4s-proposal-builder')}
            className="inline-flex items-center gap-1.5 rounded bg-primary px-4 py-2 font-label-sm text-label-sm font-semibold text-on-primary shadow-[inset_0_1px_0_rgba(255,255,255,0.2)] transition-opacity hover:opacity-90"
          >
            {t.home.exploreWorkflows}
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          aria-label={open ? 'Close menu' : 'Open menu'}
          className="flex h-10 w-10 items-center justify-center rounded text-on-surface-variant hover:text-primary md:hidden"
        >
          <Icon name={open ? 'close' : 'menu'} />
        </button>
      </div>

      {open && (
        <div className="border-t border-outline-variant bg-surface px-4 py-4 md:hidden">
          <nav className="flex flex-col gap-1">
            {items.map((it) => (
              <NavLink
                key={it.to}
                to={it.to}
                end={it.end}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `font-body-md text-body-md rounded px-3 py-3 transition-colors ${
                    isActive
                      ? 'bg-primary-container/10 text-primary'
                      : 'text-on-surface-variant hover:bg-surface-container-low hover:text-primary'
                  }`
                }
              >
                {it.label}
              </NavLink>
            ))}
          </nav>
          <div className="mt-4 flex items-center justify-between border-t border-outline-variant pt-4">
            <LanguageToggle />
            <button
              type="button"
              onClick={() => {
                setOpen(false)
                navigate('/workflows/ai4s-proposal-builder')
              }}
              className="rounded bg-primary px-4 py-2 font-label-sm text-label-sm font-semibold text-on-primary"
            >
              {t.home.exploreWorkflows}
            </button>
          </div>
        </div>
      )}
    </header>
  )
}
